import { AfterContentInit, Component, Input } from '@angular/core'
import { Commission, CurrencyAmount, Fees } from '../../../../../../graphql'

@Component({
    selector: 'app-reseller-commission-calculation',
    templateUrl: 'reseller-commission-calculation.html',
    styleUrls: ['reseller-commission-calculation.scss']
})
export class ResellerCommissionCalculationComponent implements AfterContentInit {
    @Input() commission: Commission
    @Input() exactFee: Fees
    @Input() lowestFee: Fees
    @Input() highestFee: Fees
    @Input() modifierClasses: string

    @Input() caption: string = 'Com'
    @Input() showPercentage = true
    @Input() showAmount = true
    showRange = false

    ngAfterContentInit(): void {
        if (!this.commission) {
            return
        }

        if (this.lowestFee?.bookingFee?.amountMicros === this.highestFee?.bookingFee?.amountMicros) {
            this.highestFee = undefined
        }

        this.showRange = !!this.lowestFee?.bookingFee && !!this.highestFee?.bookingFee
    }

    calculateCommission(fees: Fees): CurrencyAmount {
        // TODO: Consider using API endpoint:
        //       commission(listingId: ID!, price: CurrencyAmount): Commission @auth

        let commissionMicros = this.commission.rate * fees.bookingFee.amountMicros / 100
        return {
            amountMicros: commissionMicros,
            currency: fees.bookingFee.currency
        }
    }
}
